import { AccountAddress } from "@aptos-labs/ts-sdk";

/** Accepts any short form (RPC and indexer disagree on zero-padding); unparseable input case-folds instead of throwing. */
export function addressComparisonKey(address: string): string;
export function addressComparisonKey(address: string | undefined): string | undefined;
export function addressComparisonKey(address: string | undefined): string | undefined {
  if (address === undefined) return undefined;
  try {
    return AccountAddress.from(address, { maxMissingChars: 63 }).toString();
  } catch {
    return address.toLowerCase();
  }
}

/** Equality for two Aptos addresses that may disagree on zero-padding or case. */
export function addressesEqual(a: string | undefined, b: string | undefined): boolean {
  if (!a || !b) return false;
  return addressComparisonKey(a) === addressComparisonKey(b);
}
